export enum InputFieldEnum {
  TEXT = 'text',
  MULTITEXT = 'multitext',
  DATE = 'date',
  EMAIL = 'email',
  POSTCODE = 'postcode',
  TELEPHONE = 'telephone',
  RADIO = 'radio',
  SELECT = 'select',
}
